import React, { useEffect, useState } from 'react';
import { Input, Modal } from 'antd';

const WaitingModal = ({ visible, isWaiting, loading, onCancel, onOk }) => {
  const [comment, setComment] = useState('');

  useEffect(() => {
    if (visible) setComment('');
  }, [visible]);

  const trimmedComment = comment.trim();

  const title = isWaiting
    ? 'Выключение признака заявки “Ожидание”'
    : 'Включение признака заявки “Ожидание”';

  return (
    <Modal
      visible={visible}
      title={title}
      okText="Сохранить"
      cancelText="Отмена"
      confirmLoading={loading}
      okButtonProps={{ disabled: !trimmedComment }}
      onOk={() => onOk(trimmedComment)}
      onCancel={onCancel}
      destroyOnClose
    >
      <div style={{ marginBottom: '8px' }}>Укажите причину:</div>
      <Input.TextArea
        value={comment}
        placeholder="Комментарий"
        autosize={{ minRows: 3, maxRows: 6 }}
        onChange={(e) => setComment(e.target.value)}
      />
    </Modal>
  );
};

export default WaitingModal;
